export enum CronErrors {
  RELOAD_FEEDS_FAILED = 'Failed to reload feeds',
  PROCESS_IMAGES_FAILED = 'Failed to process Instagram images',
  NO_PRODUCTS_WITH_HASHTAGS = 'No products with Instagram hashtags found',
  BATCH_LIMIT_EXCEEDED = 'Batch limit exceeded - try again later',
  INVALID_POSTS_FOUND = 'Invalid posts found (non-image or missing URLs)',
  SERVER_ERROR_PROCESSING = 'Server error during image processing',
  IMAGE_PROCESSING_FAILED = 'Image processing failed',
}
